import styles from "./style.module.css";
import commonStyles from "../../../Layout/Fullpage/style.module.css";
import SectionHeader from '../../../SectionHeader';
import FaqAccordian from "./faqAccordian";

function FaqSection({planDetails}) {

    console.log("planDetails", planDetails)

    return (
        <>
            <section className={`${styles['faq-section']} pb-5`} >
                {/* <Sectio nHeader headerText={'FAQs'} /> */}
                <FaqAccordian planDetails={planDetails}/>
            </section>
        </>
    )
}

export default FaqSection
